import React, {useEffect, useState} from 'react';

import DDUMainWipers from "./components/wipers";
import DDUMainMenu from "./components/menu";
import DDUMainHeadlights from "./components/headlights";
import DDUMainEngine from "./components/engine";

import DDUMainSession from "./components/session";
import DDUMainPosition from "./components/position";
import DDUMainLaps from "./components/laps";

import DDUMainDelta_Gear_RPM from "./components/delta_gear_rpm";
import DDUMainSpeed from "./components/speed";
import DDUMainTrack_Air from "./components/track_air";

import DDUMainCarDamage from "./components/car-damage";

import DDUMainTires from "./components/tires";

import DDUMainLapTimes from "./components/lap-times";

import DDUMainLeaderboard from './components/leaderboard';

function DDUMain({value, userData, changeHUD, setChangeHUD, leaderboard}) {
    const [hudState, setHudState] = useState("main")
    const [hasPlayerBestLap, setHasPlayerBestLap] = useState(false)

    useEffect(() => {
        if (changeHUD) {
            if (hudState === "main") {
                setHudState("leaderboard")
            } else if (hudState === "leaderboard") {
                setHudState("car_damage")
            } else {
                setHudState("main")
            }

            setChangeHUD(false)
        }
    }, [changeHUD, hudState])


    useEffect(() => {
        const PLAYER_FULL_NAME = `${value["player-name"]} ${value["player-surname"]}`;
        
        const playerIsRecordHolder = leaderboard.some(driver => 
            driver.name === PLAYER_FULL_NAME && driver["has-best-lap"] === true
        );

        if (playerIsRecordHolder === true) {
            setHasPlayerBestLap(true);
        } else {
            setHasPlayerBestLap(false);
        }

    }, [leaderboard, value]);

    return (
        <div class="dash-grid grid grid-cols-5 grid-rows-5 gap-4 text-white w-full h-[80%]">
            {hudState === "main" &&
                <>
                    <div class="icons-grid-left col-span-2 flex items-center justify-center border-[#137fec33] border-[2px] rounded overflow-hidden p-1 gap-1">
                        <DDUMainHeadlights value={value}/>
                        <DDUMainMenu value={value}/>
                        <DDUMainWipers value={value}/>
                        <DDUMainEngine value={value}/>
                    </div>

                    <div className="col-span-2 col-start-4 row-start-1 flex items-center justify-center border-[#137fec33] border-[2px]">
                        <DDUMainSession value={value}/>
                        <DDUMainPosition value={value}/>
                        <DDUMainLaps value={value}/>
                    </div>
                </>
            }

            {hudState === "leaderboard" &&
                <div className="col-span-4 row-span-5 dash-leaderborad flex flex-col border-white border-[2px] overflow-hidden">
                    <DDUMainLeaderboard value={value} leaderboard={leaderboard}/>
                </div>
            }

            {hudState === "car_damage" &&
                <div className="col-span-4 row-span-5 dash-leaderborad flex flex-col border-white border-[2px] overflow-hidden">
                    <DDUMainCarDamage value={value} userData={userData}/>
                </div>
            }

            <div className={`${(hudState === "leaderboard") || (hudState === "car_damage") ? "row-span-5 col-start-5" : "row-span-5 col-start-3 row-start-1"} flex flex-col items-center rounded-t-[10px] gap-1`}>
                <DDUMainDelta_Gear_RPM value={value}/>
                <DDUMainSpeed value={value}/>
                <DDUMainTrack_Air value={value}/>
            </div>
            
            {hudState === "main" &&
                <>
                    <div className="relative col-span-2 row-span-4 row-start-2 flex items-center justify-center border-[#137fec33] border-[2px] rounded">
                        <DDUMainTires value={value} userData={userData}/>
                    </div>

                    <div className="relative col-span-2 row-span-4 col-start-4 row-start-2 flex flex-col items-center justify-center border-[#137fec33] border-[2px] rounded">
                        <DDUMainLapTimes value={value} hasPlayerBestLap={hasPlayerBestLap}/>
                    </div>
                </>
            }
        </div>
    );
}

export default DDUMain;